import http from '../http'

/**
 * 登录获取token
 * @param param
 * @returns {AxiosPromise}
 */
export function userLogin(param) {
  return http({
    url: '/api/auth/login',
    method: 'post',
    data: param,
    urlType: 'meteSoil'
  })
}

/**
 * 获取用户登录信息
 * @returns {AxiosPromise}
 */
export function getAuth() {
  return http({
    url: '/api/auth/user/',
    method: 'get',
    urlType: 'meteSoil'
  })
}

/**
 * 修改密码
 * @param param
 * @returns {AxiosPromise}
 */
export function changePassword(param) {
  return http({
    url: '/api/auth/changePassword',
    method: 'post',
    data: param,
    urlType: 'meteSoil'
  })
}



// WEBPACK FOOTER //
// ./src/until/api/login.js